import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 所有的组件集合
import './components'
// 处理1px
import './util/scale_750.js'
Vue.use(VueAwesomeSwiper)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data () {
    return {
      transitionName: 'slide-right'
    }
  },
  components: { App },
  template: '<App/>',
  watch: {
    '$route' (to, from) {
      this.transitionName = from.name === 'home' ? 'slide-left' : 'slide-right'
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js